/*******************************************************************************
 *                                                                             *
 * WARNING! This file was automatically generated from the server-side model!  *
 * You shouldn't edit this by hand.  If you want to modify the client-side     *
 * model behavior, you should modify: ../ModelDetentionControl.ts              *
 *                                                                             *
/*******************************************************************************/

import { Endpoint, ModelRow, RowConstructor } from "@mcleod/core";

const endpointPath = "lme/general/detention-control";

export class AutogenModelDetentionControl<RowType extends ModelRow> extends Endpoint<RowType, RowDetentionControlFields> {
	constructor(ctor: RowConstructor) {
		super(endpointPath, ctor);
	}
}

export class AutogenRowDetentionControl extends ModelRow<RowDetentionControlFields> {
	constructor(values?: Partial<RowDetentionControlFields>) {
		super(endpointPath, true, values);
	}
}

export interface RowDetentionControlFields {
	appt_missed: string;
	company_id: string;
	default_hist_view_days: number;
	departure_dist: number;
	departure_dist_um: string;
	email_billing: string;
	email_errors: string;
	email_reply: string;
	freq_chg_hours: number;
	freq_chg_minutes: number;
	freq_warn_hours: number;
	freq_warn_minutes: number;
	id: number;
	is_active: string;
	template_email: number;
	template_fax: number;
	text_arrival: string;
	text_charge: string;
	text_departure: string;
	text_warning: string;
	use_showas_location: string;
}

